import {TranslationEffects} from "./entities/system-configurations/temp-fcrs/translation/translation.effects";
import {AuthUserEffects} from "./entities/uaa/auth-user.effects";
import {RegionEffects} from "./entities/system-configurations/administrative-area/region/region.effects";
import {DistrictEffects} from "./entities/system-configurations/administrative-area/district/district.effects";
import {WardEffects} from "./entities/system-configurations/administrative-area/ward/ward.effects";
import {CurrencyEffects} from "./entities/system-configurations/temp-fcrs/currency/currency.effects";

import {SystemUserRoleEffects} from "./entities/system-configurations/temp-fcrs/system-user-role/system-user-role.effects";

import {StreetEffects} from "./entities/system-configurations/administrative-area/street/street.effects";
import {StoreItemEffects} from "./entities/store-item/store-item.effects";


export const effects = [
  AuthUserEffects,
  TranslationEffects,
  RegionEffects,
  DistrictEffects,
  WardEffects,
  CurrencyEffects,
  SystemUserRoleEffects,
  StreetEffects,
  StoreItemEffects
];
